import DataUniPolaireDepressie from "../../../../src/client/nvvp/json/unipolaire-depressie-zonder-melancholische-of-psychotische-kenmerken.json";
import ChartBasicSchematic from "../../../../src/components/interactions/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  DataUniPolaireDepressie,
  ChartBasicSchematic,
  React
};